<template>
    <v-popover offset="0" :open="isOpen" trigger="click" :autoHide="true" v-on:auto-hide="close">

        <span class="tooltip-target" data-testid="client-banner-psa" @click="open">
            <template v-if="client.sorted_measurement_records && client.sorted_measurement_records.psa">
                <span class="badge badge-primary" data-testid="client-psa-badge" v-tooltip="{
                        content: 'měřeno: <b>' + client.sorted_measurement_records.psa.data[0].measure_date + '</b>',
                        placement: 'bottom-center',
                        classes: ['info']}">
                  <strong>PSA:</strong> {{ client.sorted_measurement_records.psa.data[0].value }} {{ client.sorted_measurement_records.psa.measurand.unit }}
                </span>
            </template>
        </span>
        <template slot="popover">
            <div class="container tooltip_container tooltip_1_5_col" data-testid="client-psa-popover" v-if="client.sorted_measurement_records && client.sorted_measurement_records.psa">
                <div class="row tooltip_header">
                    <div class="col-sm-12">PSA</div>
                </div>

                <div>
                    <div class="row">
                        <table class="table">
                            <tbody>
                            <template v-for="record in client.sorted_measurement_records.psa.data">
                                <template>
                                  <tr class="row m-0 text-left" data-testid="client-psa-row">
                                    <td class="col-sm-6 text-left"><strong>{{ record.value }}</strong> {{ client.sorted_measurement_records.psa.measurand.unit }}</td>
                                    <td class="col-sm-6 text-right">{{ record.measure_date }}</td>
                                  </tr>
                                  <tr class="row m-0 no-top-border-td no-padding-top-td" v-if="record.note">
                                    <td class="col-sm-1"></td>
                                    <td class="col-sm-11 font-italic text-left">
                                      <span data-testid="client-psa-note">{{ record.note }}</span>
                                    </td>
                                  </tr>
                                </template>
                            </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </v-popover>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        isOpen: false
      }
    },
    mixins: [apiMixin],
    props: ['client', 'clientHeader'],
    methods: {
      open () {
        this.isOpen = true
      },
      close () {
        this.isOpen = false
      }
    },
    watch: {
      isOpen (val) {
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .badge_large {
        font-size: xx-large;
    }
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .input-group.input-group-unstyled input.form-control {
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
    }
    .input-group-unstyled .input-group-addon {
        border-radius: 4px;
        border: 0px;
        background-color: transparent;
    }
    .row_description {
    }
    .row_description > td {
        padding-bottom: 1px;
        border: none;
        font-size: smaller;
    }
    .row_data {
    }
    .row_data > td {
        padding-top: 0px;
        font-weight: bold;
        font-size: large;
        border: none;
    }

    .no-top-border-td > td {
        border-top: none;
    }

    .no-padding-top-td > td {
        padding-top: 0;
    }

    .width_fix {
        width: 100%;
    }
    .label_like {
        max-width: 100%;
        /*font-weight: bold;*/
    }
    .main_attribute {
        max-width: 100%;
        font-size: x-large;
        font-weight: bold;
    }

    .custom_panel_heading {
        border-bottom: none;
        padding-bottom: 0;
        background-color: #b5e3cf;
    }

    .custom_panel_heading .nav-tabs {
        border-bottom: none;
    }

    .custom_panel_heading .nav-tabs > li > a {
        background-color: #fff;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(odd) {
        margin-right: 0;
    }

    .custom_panel_heading .nav-tabs > li:nth-child(even) {
        margin-left: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/Client/components/ClientPSA.vue?2f2c3b50